import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../shared/auth.service';
import {map} from "rxjs/operators";

@Component({
  selector: 'user-account-settings',
  templateUrl: './user-account-settings.component.html',
  styleUrls: ['../styles/account-form.scss', './user-account-settings.component.scss']
})
export class UserAccountSettingsComponent implements OnInit {

  invoicingAllowed$ = this.Auth.user$.pipe(map(user => user && user.invoicingAllowed));

  constructor(private Auth: AuthService) {
  }

  ngOnInit() {
  }
}
